import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import {
  Card,
  CardContent,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControlLabel,
} from "@mui/material";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLoginMutation } from "../../store/api/authApi";
import Language from "../../components/Language/Language";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import image from "../../images/graph.png";
import { CommonTextBox, Password } from "../../components/TextBox";
import { useDispatch } from "react-redux";
import { setCredentials } from "../../store/slice/authSlice";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from 'react-i18next'
import { OndemandVideo } from "@mui/icons-material";
import Faq from "../Layout/Faq";
import { onIndividual } from "../../store/slice/otherSlice";


export default function Login() {
  const { t } = useTranslation('login')
  const { t: l } = useTranslation('loginAndRegister')

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [postLogin, { isLoading }] = useLoginMutation();

  const CustomToast = ({ message }) => (
    <div id="staticID">
      {message}
    </div>
  );
  const showErrorToast = (errorMessage) => {
    toast.error(<CustomToast message={errorMessage} />, {
    });
  };

  const handleLogin = async (e) => {
    const data = await postLogin({ email, password });
    dispatch(setCredentials(data, email));
    if (data?.error) {
      showErrorToast(`${data?.error?.data?.errors?.email || data?.error?.data?.errors?.password}`);
    } else if (data?.data?.statusCode === 200) {
      // data?.data?.data?.isEvaluation ? navigate("/evaluation-form") : navigate("/");
      if (data?.data?.data?.isEvaluation) {
        navigate('/supplier-evaluation')
        dispatch(onIndividual(false))
        // localStorage.setItem('isAuthentication', true)
      } else {
        navigate('/')
      }
    }

    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', 'en');
    }
  };

  const handleLoginIndividual = async (e) => {
    const data = await postLogin({ email, password });
    dispatch(setCredentials(data, email));
    if (data?.error) {
      showErrorToast(`${data?.error?.data?.errors?.email || data?.error?.data?.errors?.password}`);
    } else if (data?.data?.statusCode === 200) {
      // data?.data?.data?.isEvaluation ? navigate("/evaluation-form") : navigate("/");
      if (data?.data?.data?.isEvaluation) {
        navigate(`/supplier-evaluation`)
        dispatch(onIndividual(true))
        // localStorage.setItem('isAuthentication', true)
      } else {
        navigate('/')
      }
    }

    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', 'en');
    }
  };


  const [open, setOpen] = useState(false)
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };



  const url1 = "https://www.youtube.com/watch?v=HhYQTHZHKLM";
  const url2 = "https://www.youtube.com/watch?v=Adadcoqfgh0";

  const getEmbedUrl = () => {
    const langCode = localStorage.getItem('lang')

    const selectedUrl = langCode === "az" ? url2 : url1;

    const videoId = selectedUrl.split("v=")[1];
    return `https://www.youtube.com/embed/${videoId}`;
  };
  const contentLogin = (
    <>
      <Box
        sx={{
          display: "flex",
          aligntItems: "center",
          justifyContent: "space-between",
          mt: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: '20px' }}>
          <Avatar sx={{ m: 1, backgroundColor: "#2196f3" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {l('loginName')}
          </Typography>

        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Button
            onClick={handleClickOpen}
            type="submit"
            variant="contained"
            startIcon={<OndemandVideo />}
            sx={{ mr: 2 }}
          >
            {t('videoGuide')}
          </Button>
          <Language />
        </Box>
      </Box>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin();
        }}
      >
        <Grid
          container
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} mt={2} mb={2}>
            <CommonTextBox
              required
              name={'email'}
              label={l("emailAddress")}
              value={email}
              setValue={setEmail}
            />
          </Grid>
          <Grid item xs={12} mb={2}>
            <Password password={password} setPassword={setPassword} />
          </Grid>
        </Grid>

        <Grid
          container
          display="flex"
          alignItems="flex-start"
          justifyContent="space-between"
        >
          <Grid item>

          </Grid>
          <Grid item>
            <Link
              to="/forget-password"
              style={{
                color: "#4a4848",
                textDecoration: "inherit",
                fontSize: 12,
              }}
            >
              {t("forgotPassword")}?
            </Link>
          </Grid>
        </Grid>

        <Grid
          container
          display="flex"
          alignContent="space-around"
          justifyContent="center"
          mt={2}
        >
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "center", gap: '20px' }}
            mb={4}
          >
            <LoadingButton
              size="small"
              type="submit"
              onClick={handleLogin}
              loading={isLoading}
              loadingPosition="start"
              variant="contained"
              sx={{ width: 250 }}
              name={'loginBtn'}
            >
              <span>{l('loginName')}</span>
            </LoadingButton>
            <LoadingButton
              size="small"
              onClick={() => {
                window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${process.env.REACT_APP_MS_CLIENT_ID}&response_type=code&redirect_uri=${process.env.REACT_APP_MS_REDIRECT_URL}&scope=openid%20profile%20email%20User.Read`
              }}
              loading={isLoading}
              loadingPosition="start"
              variant="contained"
              sx={{ width: 250 }}
              name={'loginBtn'}
            >
              <span>{l('loginMicrosoft')}</span>
            </LoadingButton>

          </Grid>


          <LoadingButton
            color="secondary"
            size="small"
            type="submit"
            onClick={handleLoginIndividual}
            loading={isLoading}
            loadingPosition="start"
            variant="contained"
            sx={{ width: 250, mb: 3 }}
            name={'loginBtn'}
          >
            <span>{l('loginIndividual')}</span>
          </LoadingButton>
        </Grid>
      </form>

      <Divider />

      <Grid
        container
        display="flex"
        alignItems="center"
        justifyContent="center"
        mt={1}
      >
        <Grid item>
          <Typography variant="subtitle1">{t("question")}</Typography>
        </Grid>
      </Grid>


      <Grid
        container
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Grid item >
          <Button
            onClick={() => navigate("/register-supplier")}
            type="submit"
            variant="contained"
            sx={{ width: 250, backgroundColor: "#4f9fcb" }}
          >
            {l("supplier")}
          </Button>

        </Grid>
      </Grid>

      <Grid
        container
        display="flex"
        alignItems="flex-end"
        justifyContent="flex-end"
      >
        <Grid item mt={10}>
          <Faq />
        </Grid>
      </Grid>



      <Dialog
        maxWidth="1000px"
        open={open}
        onClose={handleClose}
      >
        <Box sx={{ height: 450, width: 1000 }}>
          <DialogContent>
            <iframe
              width="100%"
              height="400"
              src={open ? getEmbedUrl() : ''}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title={'EE'}
            />
          </DialogContent>
        </Box>

        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );

  const contentText = (
    <>
      <img
        alt="Under development"
        src={image}
        style={{
          position: "absolute",
          zIndex: -1,
          top: -250,
          left: -110,
          opacity: "10%",
        }}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 150,
        }}
      >
        <Typography variant="h4" sx={{ color: "white" }}>
          Sola Soft
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 150,
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{ color: "white", textAlign: "center" }}
        >
          {l("slogan")}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
          height: 180,
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{ color: "black", textAlign: "center" }}
        >
          Apertech MMC copyright © 2025 all rights reserved
        </Typography>
      </Box>
    </>
  );

  return (
    <div className="animation-bg">
      <Grid container width={{ xs: 400, sm: 400, md: 800 }}>
        <Grid
          item
          sx={{ display: { xs: "none", sm: "none", md: "block" } }}
          md={4}
          lg={4}
          xl={4}
        >
          <Card
            sx={{
              zIndex: 2,
              position: "relative",
              backgroundColor: "#2196f3",
              height: 500,
            }}
          >
            <CardContent>{contentText}</CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
          <Card sx={{ zIndex: 2, position: "relative", height: 500 }}>
            <CardContent>{contentLogin}</CardContent>
          </Card>
        </Grid>
      </Grid>
      <div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
      </div>
    </div>
  );
}